import { render, staticRenderFns } from "./CatalogIntegration.vue?vue&type=template&id=553bbce8&scoped=true&"
import script from "./CatalogIntegration.vue?vue&type=script&lang=js&"
export * from "./CatalogIntegration.vue?vue&type=script&lang=js&"
import style0 from "./CatalogIntegration.vue?vue&type=style&index=0&id=553bbce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553bbce8",
  null
  
)

export default component.exports